var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgTestemunhos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "91px",
    viewBox: "0 0 83 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_testemunhos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-2612.000000, -431.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 5.5434456
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_testemunhos",
    transform: "translate(2615.000000, 434.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.804779,73.4402502 C50.2246317,74.0352502 49.6859741,75.1401049 49.5616568,75.9476049 L48.7743039,81.6850011 C48.4842303,83.7675012 49.8932,85.2125426 51.9237156,84.9150426 L57.5178922,84.1075323 C58.305235,83.9800323 59.4242018,83.4275841 59.96291,82.8325841 L74.6322584,67.7876765 C77.1600432,65.1951765 78.3617768,62.177542 74.6322584,58.3525421 C70.944179,54.5700422 68.0021652,55.8025836 65.4743804,58.3950836 L50.804779,73.4402502 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.361043,60.5625 C64.6042158,65.1525002 68.0849781,68.7223754 72.5604005,69.9973755",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,85 C0,68.5525005 15.9541636,55.25 35.5962933,55.25 C39.905959,55.25 44.0497471,55.8874689 47.9035829,57.0774689",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5965462,42.5 C24.153456,42.5 14.8769991,32.9860513 14.8769991,21.25 C14.8769991,9.51394874 24.153456,0 35.5965462,0 C47.0396365,0 56.3160934,9.51394874 56.3160934,21.25 C56.3160934,32.9860513 47.0396365,42.5 35.5965462,42.5 Z",
    id: "Vector"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgTestemunhos);
export default __webpack_public_path__ + "static/media/svg_testemunhos.f0af8dcc0631aff017aa3436d1b482cf.svg";
export { ForwardRef as ReactComponent };